import { defineStore } from 'pinia';
import { ref } from 'vue';

type AlertType = 'error' | 'success' | 'warning' | 'info';

export const useAlertStore = defineStore('alert', () => {
  const alert = ref<{
    message: string;
    type: AlertType;
  } | null>(null);

  const show = (message: string, type: AlertType = 'error') => {
    clear();
    alert.value = { message, type };
  };

  const clear = () => {
    alert.value = null;
  };

  return { alert, show, clear };
});